import OpenSourceCredits from "./pages/OpenSourceCredits.svelte";
import Servers from "./pages/Servers.svelte";
const SLAKRoutes = [
    {
        kind: "internal +navbar",
        path: "about",
        navItem: {
            alt: "about navigation item",
            imageName: "about",
        },
        content: {
            main: [{ file: "About.md", options: { justify: true } }],
        },
    },
    {
        kind: "external +navbar",
        href: "http://www.slak.com.au/phpBB3/index.php",
        navItem: {
            alt: "forums navigation item",
            imageName: "forums",
        },
    },
    {
        kind: "internal +navbar",
        path: "files",
        navItem: {
            alt: "files navigation item",
            imageName: "files",
        },
        content: {
            main: [{ file: "ComingSoon.md" }],
        },
    },
    {
        kind: "internal +navbar",
        path: "leagues",
        navItem: {
            alt: "leagues navigation item",
            imageName: "leagues",
        },
        content: {
            main: [{ file: "ComingSoon.md" }],
        },
    },
    {
        kind: "internal custom +navbar",
        path: "servers",
        navItem: {
            alt: "servers navigation item",
            imageName: "servers",
        },
        component: Servers,
    },
    {
        kind: "internal +navbar",
        path: "slakfest",
        navItem: {
            alt: "SLAKfest navigation item",
            imageName: "slakfest",
        },
        content: {
            main: [{ file: "SLAKfest.md" }],
            side: [
                { file: "SLAKfest_upcoming.md" },
                { file: "SLAKfest_location.md" },
            ],
        },
    },
    {
        kind: "internal +navbar",
        path: "sponsors",
        navItem: {
            alt: "sponsors navigation item",
            imageName: "sponsors",
        },
        content: {
            main: [{ file: "ComingSoon.md" }],
        },
    },
    {
        kind: "internal +navbar",
        path: "contact",
        navItem: {
            alt: "contact navigation item",
            imageName: "contact",
        },
        content: {
            main: [{ file: "ComingSoon.md" }],
        },
    },
    {
        kind: "internal custom",
        path: "open-source",
        component: OpenSourceCredits,
    },
];
export default SLAKRoutes;
